import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-admin-list',
  templateUrl: './admin-list.component.html',
  styleUrls: ['./admin-list.component.css']
})
export class AdminListComponent implements OnInit {

  @Input() adminList;
  @Output() changeAction = new EventEmitter();
  @Output() selectAction = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  changeAdmin(data) {
    this.changeAction.emit(data);
  }

  selectAdmin(data) {
    this.selectAction.emit(data);
  }

}
